/**
 * platformNavigation — navigation Master Shell (prototype Redesign « Rectorium - Master Shell 0 »).
 * Le Master Shell gère les tenants (universités clientes) et la plateforme SaaS — rien d'autre.
 * PUR (testable).
 */

export const OPERATOR_SECTIONS = ['platform_admin', 'rectorium_ops', 'rectorium_corporate'];

export const OPERATOR_WORKSPACES = {
  master: {
    id: 'master',
    label: 'Rectorium Ops',
    labelKey: 'nav.workspace.master_label',
    sublabel: 'Opérateur Platform Admin',
    sublabelKey: 'nav.workspace.master_sublabel',
    defaultRoute: '/dashboard/rectorium-command-center',
  },
};

/**
 * MASTER_NAV — structure EXACTE du prototype Redesign (4 sections / 13 entrées).
 * Chaque entrée pointe vers une vue réelle (données Supabase). Les anciennes vues
 * Ops/Corporate restent accessibles par URL directe mais ne sont plus dans la nav.
 */
export const MASTER_NAV = [
  { sectionKey: 'master_supervision', title: 'Supervision', titleKey: 'nav.sections.master_supervision', items: [
    { id: 'master-fleet', label: 'Vue flotte', labelKey: 'nav.items.master-fleet',          icon: 'Globe',        path: '/dashboard/rectorium-command-center', pairPath: '/dashboard/master-platform' },
    { id: 'master-lifecycle', label: 'Pipeline Lifecycle', labelKey: 'nav.items.master-lifecycle',  icon: 'Network',      path: '/dashboard/rectorium-tenant-lifecycle', pairPath: '/dashboard/master-platform' },
    { id: 'master-activation', label: 'Activation tenants', labelKey: 'nav.items.master-activation',  icon: 'Rocket',       path: '/dashboard/master-onboarding', pairPath: '/dashboard/master-platform' },
    { id: 'master-health', label: 'Santé & Alertes', labelKey: 'nav.items.master-health',        icon: 'Bell',         path: '/dashboard/rectorium-health', pairPath: '/dashboard/master-platform' },
    { id: 'master-analytics', label: 'Analytics & Rapports', labelKey: 'nav.items.master-analytics', icon: 'BarChart3', path: '/dashboard/rectorium-analytics', pairPath: '/dashboard/master-platform' },
    { id: 'master-agent', label: 'Agent IA', labelKey: 'nav.items.master-agent',              icon: 'Bot',          path: '/dashboard/rectorium-ai-agent', pairPath: '/dashboard/master-platform' },
  ]},
  { sectionKey: 'master_infrastructure', title: 'Infrastructure', titleKey: 'nav.sections.master_infrastructure', items: [
    { id: 'master-services', label: 'État des services', labelKey: 'nav.items.master-services',   icon: 'Server',       path: '/dashboard/rectorium-infrastructure', pairPath: '/dashboard/master-config-platform' },
    { id: 'master-errors', label: 'Erreurs & Logs', labelKey: 'nav.items.master-errors',      icon: 'ShieldCheck',  path: '/dashboard/rectorium-devops', pairPath: '/dashboard/master-config-platform' },
    { id: 'master-ai', label: 'IA Usage', labelKey: 'nav.items.master-ai',            icon: 'Cpu',          path: '/dashboard/rectorium-ai-governance', pairPath: '/dashboard/master-config-platform' },
  ]},
  { sectionKey: 'master_commercial', title: 'Commercial', titleKey: 'nav.sections.master_commercial', items: [
    { id: 'master-billing', label: 'Facturation', labelKey: 'nav.items.master-billing',         icon: 'Banknote',     path: '/dashboard/rectorium-billing-revenue', pairPath: '/dashboard/rectorium-licensing' },
    { id: 'master-plans', label: 'Forfaits', labelKey: 'nav.items.master-plans',            icon: 'Package',      path: '/dashboard/rectorium-licensing', pairPath: '/dashboard/rectorium-licensing' },
    { id: 'master-pplr', label: 'Provision Licence', labelKey: 'nav.items.master-pplr',     icon: 'PiggyBank',    path: '/dashboard/rectorium-provision-licence', pairPath: '/dashboard/rectorium-provision-licence' },
  ]},
  { sectionKey: 'master_equipe', title: 'Équipe', titleKey: 'nav.sections.master_equipe', items: [
    { id: 'master-cs', label: 'Customer Success', labelKey: 'nav.items.master-cs',    icon: 'HeartHandshake', path: '/dashboard/rectorium-customer-success', pairPath: '/dashboard/rectorium-team' },
    { id: 'master-support', label: 'Support & Tickets', labelKey: 'nav.items.master-support',   icon: 'LifeBuoy',     path: '/dashboard/rectorium-support', pairPath: '/dashboard/rectorium-team' },
    { id: 'master-comms', label: 'Communication tenants', labelKey: 'nav.items.master-comms', icon: 'MessageSquare', path: '/dashboard/rectorium-communications', pairPath: '/dashboard/rectorium-team' },
    { id: 'master-team', label: 'Annuaire opérateurs', labelKey: 'nav.items.master-team', icon: 'Users2',       path: '/dashboard/rectorium-team', pairPath: '/dashboard/rectorium-team' },
    { id: 'master-r4r', label: 'Rectorium for Rectorium', labelKey: 'nav.items.master-r4r', icon: 'Building2', path: '/dashboard/rectorium-r4r', pairPath: '/dashboard/rectorium-team' },
  ]},
  // Nouvelle section (audit 2026-07-11, décision Alfred) : MasterPlatformView.jsx
  // (Console Master Platform, 9 onglets Tenants/Licences/Domaines/Tarification/
  // Sauvegardes/Executive/Supervision Tech/Supervision Acad/Sécurité) était
  // orpheline du menu — route /dashboard/master-platform accessible seulement
  // par URL directe ou via le crayon de config-tenants. Rattachement minimal :
  // les 9 onglets internes restent des onglets (pas 9 routes séparées) pour
  // l'instant — approche progressive validée par Alfred.
  { sectionKey: 'master_platform_mgmt', title: 'Gestion de la plateforme', titleKey: 'nav.sections.master_platform_mgmt', items: [
    { id: 'master-platform', label: 'Console plateforme', labelKey: 'nav.items.master-platform', icon: 'LayoutDashboard', path: '/dashboard/master-platform', pairPath: '/dashboard/master-platform' },
    // Personnalisation de la page de connexion Master (exigence Alfred
    // 2026-07-12) : logo + diaporama + message d'accueil, sans bascule de
    // contexte — ce que Master Login lit via get_tenant_public_identity('global').
    { id: 'master-login-branding', label: 'Page de connexion', labelKey: 'nav.items.master-login-branding', icon: 'Palette', path: '/dashboard/master-login-branding', pairPath: '/dashboard/master-login-branding' },
    // Centre de sauvegardes & exports (exigence Alfred 2026-07-12) : export
    // CSV/JSON des données réelles par domaine — aucune promesse de
    // sauvegarde automatique serveur (aucun service réel derrière).
    { id: 'master-backups', label: 'Sauvegardes & exports', labelKey: 'nav.items.master-backups', icon: 'Database', path: '/dashboard/master-backups', pairPath: '/dashboard/master-backups' },
    // Apparence & thèmes (exigence Alfred 2026-07-12, « thèmes à la
    // WordPress ») : galerie de jeux de variables CSS appliqués au Master
    // Shell, persistés localStorage + tenant_branding.theme_settings.
    { id: 'master-appearance', label: 'Apparence & thèmes', labelKey: 'nav.items.master-appearance', icon: 'Sparkles', path: '/dashboard/master-appearance', pairPath: '/dashboard/master-appearance' },
  ]},
];

/**
 * MASTER_CONFIG_NAV — CONFIGURATION PLATEFORME (Mode Édition du Master Shell).
 * MIROIR des 4 sections de MASTER_NAV : chaque entrée édite ce que le mode
 * Lecture montre (doctrine DWA : Premium View ↔ Configuration View appariées
 * sur le même périmètre métier). `pairPath` = route de la vue Lecture jumelle
 * (toggle œil/crayon). Zéro entrée décorative : chaque route écrit dans des
 * tables réelles (pricing_user_tiers, rectorium_team_members, tenants).
 */
export const MASTER_CONFIG_NAV = [
  { sectionKey: 'master_supervision', title: 'Supervision', titleKey: 'nav.sections.master_supervision', icon: 'Globe', items: [
    // MasterPlatformView : cycle de vie réel des tenants (activation, domaines,
    // modules — table `tenants`). Jumelle lecture : Vue flotte.
    { id: 'config-tenants', label: 'Cycle de vie tenants', labelKey: 'nav.items.config-tenants', icon: 'Network', path: '/dashboard/master-platform', pairPath: '/dashboard/rectorium-command-center' },
  ]},
  { sectionKey: 'master_infrastructure', title: 'Infrastructure', titleKey: 'nav.sections.master_infrastructure', icon: 'Server', items: [
    // Paramètres plateforme & sécurité : identité/branding du tenant `global`
    // (personnalisation de la page Master Login). Jumelle lecture : État des services.
    { id: 'config-platform', label: 'Paramètres plateforme & sécurité', labelKey: 'nav.items.config-platform', icon: 'Settings', path: '/dashboard/master-config-platform', pairPath: '/dashboard/rectorium-infrastructure' },
  ]},
  { sectionKey: 'master_commercial', title: 'Commercial', titleKey: 'nav.sections.master_commercial', icon: 'Banknote', items: [
    // MasterPlansView embarque l'edition de la grille (pricing_user_tiers) :
    // la vue est sa propre Configuration View (pairPath = elle-même).
    { id: 'config-plans', label: 'Forfaits & tarification', labelKey: 'nav.items.config-plans', icon: 'Package', path: '/dashboard/rectorium-licensing', pairPath: '/dashboard/rectorium-licensing' },
  ]},
  { sectionKey: 'master_equipe', title: 'Équipe', titleKey: 'nav.sections.master_equipe', icon: 'Users2', items: [
    // MasterTeamView embarque l'invitation/gestion des opérateurs
    // (rectorium_team_members) : pairPath = elle-même.
    { id: 'config-team', label: 'Annuaire & rôles opérateurs', labelKey: 'nav.items.config-team', icon: 'Users2', path: '/dashboard/rectorium-team', pairPath: '/dashboard/rectorium-team' },
  ]},
];

/** Libellé de page (breadcrumb « MASTER / … ») pour chaque route master. */
export const MASTER_PAGE_LABELS = [...MASTER_CONFIG_NAV, ...MASTER_NAV].reduce((acc, sec) => {
  sec.items.forEach((it) => { acc[it.path] = it.label; });
  return acc;
}, {});

// Conservé pour compatibilité : toutes ces routes appartiennent désormais au
// workspace master unique (le prototype n'a plus de workspaces Ops/Corporate).
export const OPERATOR_ROUTE_WORKSPACE_MAP = [
  { match: /^\/dashboard\/rectorium-command-center/, workspace: 'platform' },
  { match: /^\/dashboard\/master-platform/, workspace: 'platform' },
  { match: /^\/dashboard\/master-data/, workspace: 'platform' },
  { match: /^\/dashboard\/master-mgmt/, workspace: 'platform' },
  { match: /^\/dashboard\/activation-center/, workspace: 'platform' },
  { match: /^\/dashboard\/platform-ops/, workspace: 'platform' },
  { match: /^\/dashboard\/rectorium-devops/, workspace: 'platform' },
  { match: /^\/dashboard\/rectorium-operations/, workspace: 'platform' },
  { match: /^\/dashboard\/rectorium-data-quality/, workspace: 'platform' },
  { match: /^\/dashboard\/rectorium-integration-management/, workspace: 'platform' },
  { match: /^\/dashboard\/rectorium-notification-center/, workspace: 'platform' },
  { match: /^\/dashboard\/rectorium-licensing/, workspace: 'platform' },
  { match: /^\/dashboard\/rectorium-subscriptions/, workspace: 'platform' },

  { match: /^\/dashboard\/rectorium-marketplace/, workspace: 'ops' },
  { match: /^\/dashboard\/rectorium-ops/, workspace: 'ops' },
  { match: /^\/dashboard\/rectorium-ai-governance/, workspace: 'ops' },
  { match: /^\/dashboard\/rectorium-customer-success/, workspace: 'ops' },
  { match: /^\/dashboard\/rectorium-support/, workspace: 'ops' },
  { match: /^\/dashboard\/rectorium-cs-master/, workspace: 'ops' },
  { match: /^\/dashboard\/rectorium-support-master/, workspace: 'ops' },
  { match: /^\/dashboard\/master-onboarding/, workspace: 'ops' },
  { match: /^\/dashboard\/rectorium-tenant-lifecycle/, workspace: 'ops' },
  { match: /^\/dashboard\/rectorium-security/, workspace: 'ops' },
  { match: /^\/dashboard\/rectorium-infrastructure/, workspace: 'ops' },
  { match: /^\/dashboard\/rectorium-product-roadmap/, workspace: 'ops' },
  { match: /^\/dashboard\/rectorium-release-management/, workspace: 'ops' },
  { match: /^\/dashboard\/rectorium-implementation-onboarding/, workspace: 'ops' },
  { match: /^\/dashboard\/rectorium-training-knowledge/, workspace: 'ops' },
  { match: /^\/dashboard\/rectorium-automation-workflow/, workspace: 'ops' },
  { match: /^\/dashboard\/rectorium-billing-revenue/, workspace: 'ops' },
  { match: /^\/dashboard\/customer-success/, workspace: 'ops' },
  { match: /^\/dashboard\/support-master/, workspace: 'ops' },
  { match: /^\/dashboard\/devops/, workspace: 'ops' },
  { match: /^\/dashboard\/rectorium-team/, workspace: 'ops' },

  { match: /^\/dashboard\/rectorium-corporate/, workspace: 'corporate' },
  { match: /^\/dashboard\/rectorium-sales/, workspace: 'corporate' },
  { match: /^\/dashboard\/rectorium-crm/, workspace: 'corporate' },
  { match: /^\/dashboard\/rectorium-billing/, workspace: 'corporate' },
  { match: /^\/dashboard\/rectorium-partners/, workspace: 'corporate' },
  { match: /^\/dashboard\/rectorium-partner-channel/, workspace: 'corporate' },
  { match: /^\/dashboard\/rectorium-corp-finance/, workspace: 'corporate' },
  { match: /^\/dashboard\/rectorium-ceo/, workspace: 'corporate' },
  { match: /^\/dashboard\/rectorium-corp-pmo/, workspace: 'corporate' },
  { match: /^\/dashboard\/rectorium-knowledge/, workspace: 'corporate' },
  { match: /^\/dashboard\/rectorium-corp-ai/, workspace: 'corporate' },
  { match: /^\/dashboard\/rectorium-sales-pipeline/, workspace: 'corporate' },
  { match: /^\/dashboard\/rectorium-contract-legal/, workspace: 'corporate' },
  { match: /^\/dashboard\/billing-enterprise/, workspace: 'corporate' },
];

export const MASTER_LANDING_ROUTE = '/dashboard/rectorium-command-center';

export const isPlatformOwnerContext = ({ sysRoleId, tenantSlug } = {}) =>
  sysRoleId === 'master' && tenantSlug === 'global';

/**
 * Résout le workspace actif en fonction du rôle et du tenant courant.
 * (Le paramètre pathname est accepté par compatibilité mais n'influe plus :
 * le Master Shell est unique, prototype Redesign.)
 */
export function resolveOperatorWorkspace({ tenantSlug = '', sysRoleId = '' } = {}) {
  if (sysRoleId !== 'master' || tenantSlug !== 'global') {
    return 'tenant';
  }
  // Master Shell unique (prototype Redesign) : plus de séparation Platform/Ops/Corporate.
  return 'master';
}

/**
 * Filtre les groupes de navigation selon le workspace actif.
 */
export function filterNavGroupsByWorkspace(groups = [], { isEdition = false, workspace = 'tenant' } = {}) {
  // Workspace MASTER (plateforme globale) : Mode Vue → MASTER_NAV ;
  // Mode Édition → MASTER_CONFIG_NAV (Configuration Plateforme, miroir des
  // 4 sections). Le registre de configuration TENANT n'a aucun sens ici.
  if (workspace === 'master') {
    return isEdition ? MASTER_CONFIG_NAV : MASTER_NAV;
  }

  // En mode édition (DWA tenant uniquement), masquer les sections opérateur
  if (isEdition) {
    return groups.filter((g) => !['platform_admin', 'rectorium_ops', 'rectorium_corporate'].includes(g.sectionKey));
  }

  // Par défaut / mode tenant : tout SAUF les sections opérateur
  return groups.filter((g) => !['platform_admin', 'rectorium_ops', 'rectorium_corporate'].includes(g.sectionKey));
}

/**
 * applyMasterAccessScope — périmètre d'action d'un COLLABORATEUR sur
 * l'interface master (demande Alfred 2026-07-12 : défini dans la fiche modale
 * de l'Annuaire, colonne rectorium_team_members.master_access_scope).
 * `scopeIds` = null/undefined → accès complet (défaut, rétro-compatible) ;
 * tableau d'ids MASTER_NAV → seules ces entrées restent visibles.
 *
 * `alwaysKeepId` (par défaut 'master-fleet') garantit qu'un menu ne peut
 * jamais devenir totalement vide — utile pour le périmètre LIBRE historique
 * (`master_access_scope`, potentiellement []). Pour un PORTAIL DE RÔLE
 * (Phase 1 portalisation), le périmètre est TOUJOURS non-vide par
 * construction (cf. masterPortals.test.js) : forcer 'master-fleet' y
 * réintroduirait une fuite de périmètre (Vue flotte visible dans des
 * portails qui l'excluent délibérément, ex. Billing/Support) — passer
 * `null` explicitement dans ce cas (voir Sidebar.jsx).
 */
export function applyMasterAccessScope(groups = [], scopeIds = null, alwaysKeepId = 'master-fleet') {
  return applyScopeFilter(groups, scopeIds, alwaysKeepId);
}

/**
 * applyScopeFilter — filtre générique de groupes de navigation par liste
 * d'ids autorisés (Phase 1 portalisation — réutilisé par le Master ET par
 * R4R, cf. rectoriumForRectorium.js : un seul algorithme, deux registres de
 * données). `scopeIds` non-tableau (null/undefined) = accès complet, aucun
 * filtrage. `alwaysKeepId` garantit qu'un menu ne peut jamais devenir
 * totalement vide (ex. 'master-fleet' côté Master).
 */
export function applyScopeFilter(groups = [], scopeIds = null, alwaysKeepId = null) {
  if (!Array.isArray(scopeIds)) return groups;
  const allowed = new Set(alwaysKeepId ? [...scopeIds, alwaysKeepId] : [...scopeIds]);
  return groups
    .map((g) => ({ ...g, items: (g.items || []).filter((it) => allowed.has(it.id)) }))
    .filter((g) => g.items.length > 0);
}

/**
 * isMasterScopedPath — routes AUTORISÉES en workspace MASTER GLOBAL (sans
 * inspection de tenant). Tout le reste (staff, students, payments, campuses,
 * data-import, roles-permissions…) appartient à un espace tenant et doit être
 * intercepté par MasterScopeGate.
 */
const MASTER_ALLOWED_EXACT = new Set([
  '/dashboard',
  '/dashboard/',
  '/dashboard/notifications',
  '/dashboard/settings',
  // assistance / confidentialite / legal RETIRÉS (rapports Alfred 2026-07-12) :
  // vues d'ESPACE TENANT sans objet côté master — MasterScopeGate les
  // intercepte désormais (conservées telles quelles pour les tenants).
  '/dashboard/platform-ops',
  '/dashboard/tenant-onboarding',
  '/dashboard/billing-enterprise',
]);

const MASTER_ALLOWED_PREFIXES = ['/dashboard/rectorium-', '/dashboard/master-'];

export function isMasterScopedPath(pathname = '') {
  const p = String(pathname || '');
  if (MASTER_ALLOWED_EXACT.has(p)) return true;
  return MASTER_ALLOWED_PREFIXES.some((pre) => p.startsWith(pre));
}

// Keep filterNavGroups backward-compatible to avoid breaking existing imports/tests
export function filterNavGroups(groups = [], { isEdition = false, platformOwner = false } = {}) {
  if (isEdition) return groups;
  const operatorSections = ['platform_admin', 'rectorium_ops', 'rectorium_corporate'];
  return platformOwner
    ? groups.filter((g) => operatorSections.includes(g.sectionKey))
    : groups.filter((g) => !operatorSections.includes(g.sectionKey));
}
